import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { catchError, retry } from "rxjs/operators";

import { RestService } from "../rest.service";
import { LoginSendingData } from "../login/loginSendingData";

import timezoneArrayList from "../../assets/testtimeZone.json";
import { PasswordUtils } from "../utils/password.utils";


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  username: string = "";
  password: string = "";
  isUsername: boolean = false;
  isPassword: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  error: string;
  userDataAfterLogin: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private _restService: RestService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    console.warn = () => {};
    localStorage.setItem(
      "localTimeZone",
      new Date()
        .toLocaleDateString(undefined, { day: "2-digit", timeZoneName: "long" })
        .substring(4)
    );
    
    let d= new Date();
    var localOffset :any;
    localOffset = d.getTimezoneOffset();
    localStorage.setItem('localOffset',localOffset)
  }

  loginForm = this.formBuilder.group({
    username: ["", [Validators.required, Validators.email]],
    password: ["", Validators.required],
  });

  onChangeUsername() {
    console.log(this.loginForm);
    this.loginForm.controls.username.status === "INVALID"
      ? (this.isUsername = true)
      : ((this.isUsername = false), (this.error = ""));
  }

  onChangePassword() {
    console.log(this.loginForm);
    this.loginForm.controls.password.status === "INVALID"
      ? (this.isPassword = true)
      : ((this.isPassword = false), (this.error = ""));
  }

  removingBlankSpace(e: any) {
    e.target.value.substring(0, 1) === " " ? (e.target.value = "") : "";
  }

  login(e: any, username: string, password: string) {
    console.log(this.loginForm);

    var d = new Date();
    var timezoneArray: any = [];
    var timezone: any;
    var timezoneName:any;

    if (this.loginForm.status === "INVALID") {
      this.error = "Invalid Credentials";
      this.loginForm.controls.username.value === ""
        ? (this.isUsername = true)
        : (this.isUsername = false);

      this.loginForm.controls.password.value === ""
        ? (this.isPassword = true)
        : (this.isPassword = false);
    } else {
      var postData = new LoginSendingData();
      postData.email = username;
      postData.password = PasswordUtils.encryptPassword(password);

      // this.service.HttpPostRequest(postData,'/bothome/users/login').subscribe(
      //   (data)=> {
      //     console.log("log data----" , data);
      //     console.log("Login ---->", data),
      //           //TimeZone
    
      //           console.log("Time Array", timezoneArrayList),
      //           timezoneArrayList.filter((f: any) =>
               
      //             f.text.toString().toLowerCase() ===
      //             data.response.TimeZone.toString().toLowerCase()
      //               ? localStorage.setItem('selectedTimeZone', f.value)
      //               : ""
      //           ),
      //           timezoneArrayList.filter((f: any) =>
      //           f.text.toString().toLowerCase() ===
      //           data.response.TimeZone.toString().toLowerCase()
      //             ? localStorage.setItem('timezoneName', f.timezone)
      //             : ""
      //         ),
      //         timezoneArrayList.filter((f: any) =>
      //         f.text.toString().toLowerCase() ===
      //         data.response.TimeZone.toString().toLowerCase()
      //           ? localStorage.setItem('timezoneOffset', f.offset)
      //           : ""
      //       ),
      //           (timezoneArray =
      //             data.response.TimeZoneOffset.toString().split(":")),
      //           (timezone =
      //             parseInt(timezoneArray[0]) * 60 +
      //             (parseInt(timezoneArray[1]) / 60) * 60),
      //           localStorage.setItem("timezone", timezone),
      //           localStorage.setItem("adminId", data.response.id),
      //           localStorage.setItem("isSuper", data.response.IsSuper),
      //           localStorage.setItem("token", data.token),
      //           localStorage.setItem("OrgId", data.response.OrganisationId),
      //           localStorage.setItem("LoginType", data.response.LoginType),
      //           localStorage.setItem("general", data.response.GeneralNotification),
      //           localStorage.setItem("orgname", data.response.OrganisationName),
      //           localStorage.setItem(
      //             "individual",
      //             data.response.IndividualNotification
      //           ),
      //           localStorage.setItem(
      //             "integrationType",
      //             data.response.IntegrationType
      //           ),
      //           localStorage.setItem(
      //             "isCardInfoProvided",
      //             data.response.IsCardInfoProvided
      //           ),
      //           localStorage.setItem(
      //             "isSetUpInfoProvided",
      //             data.response.IsSetUpInfoProvided
      //           ),
      //           localStorage.setItem(
      //             "todayDate",
      //             (
      //               d.getDate() +
      //               "/" +
      //               (d.getMonth() + 1) +
      //               "/" +
      //               d.getFullYear()
      //             ).toString()
      //           ),
      //           localStorage.setItem("isFilter", "false"),
      //           localStorage.setItem("mids", JSON.stringify([])),
      //           localStorage.setItem("bids", JSON.stringify([])),
      //           localStorage.setItem("sids", JSON.stringify([])),
      //           localStorage.setItem("LastLogin", data.response.LastLogin),
      //           localStorage.setItem("AATokenLoaded", null),
      //           localStorage.setItem("isAATokenLoaded", "false"),
      //           this._restService.getUserDetails(data),
      //           this.router.navigate(["/schedule"])
              
      //   }
          
        
      // )

      this._restService
        .loginCondition(postData)
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.error = "Invalid Credentials";
            return e;
          })
        )
        .subscribe(
          (data) => (
            console.log("Login ---->", data),
            //TimeZone

            console.log("Time Array", timezoneArrayList),
            timezoneArrayList.filter((f: any) =>
           
              f.text.toString().toLowerCase() ===
              data.response.TimeZone.toString().toLowerCase()
                ? localStorage.setItem('selectedTimeZone', f.value)
                : ""
            ),
            timezoneArrayList.filter((f: any) =>
            f.text.toString().toLowerCase() ===
            data.response.TimeZone.toString().toLowerCase()
              ? localStorage.setItem('timezoneName', f.timezone)
              : ""
          ),
          timezoneArrayList.filter((f: any) =>
          f.text.toString().toLowerCase() ===
          data.response.TimeZone.toString().toLowerCase()
            ? localStorage.setItem('timezoneOffset', f.offset)
            : ""
        ),
            (timezoneArray =
              data.response.TimeZoneOffset.toString().split(":")),
            (timezone =
              parseInt(timezoneArray[0]) * 60 +
              (parseInt(timezoneArray[1]) / 60) * 60),
            localStorage.setItem("timezone", timezone),
            localStorage.setItem("adminId", data.response.id),
            localStorage.setItem("email", postData.email),
            localStorage.setItem("isSuper", data.response.IsSuper),
            localStorage.setItem("token", data.token),
            localStorage.setItem("OrgId", data.response.OrganisationId),
            localStorage.setItem("LoginType", data.response.LoginType),
            localStorage.setItem("general", data.response.GeneralNotification),
            localStorage.setItem("orgname", data.response.OrganisationName),
            localStorage.setItem(
              "individual",
              data.response.IndividualNotification
            ),
            localStorage.setItem(
              "integrationType",
              data.response.IntegrationType
            ),
            localStorage.setItem(
              "isCardInfoProvided",
              data.response.IsCardInfoProvided
            ),
            localStorage.setItem(
              "isSetUpInfoProvided",
              data.response.IsSetUpInfoProvided
            ),
            localStorage.setItem(
              "todayDate",
              (
                d.getDate() +
                "/" +
                (d.getMonth() + 1) +
                "/" +
                d.getFullYear()
              ).toString()
            ),
            localStorage.setItem("isFilter", "false"),
            localStorage.setItem("mids", JSON.stringify([])),
            localStorage.setItem("bids", JSON.stringify([])),
            localStorage.setItem("sids", JSON.stringify([])),
            localStorage.setItem("LastLogin", data.response.LastLogin),
            localStorage.setItem("AATokenLoaded", null),
            localStorage.setItem("isAATokenLoaded", "false"),
            this._restService.getUserDetails(data),
            this.router.navigate(["/schedule"])
          )
        );
    }
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }
}
